import React, {Fragment} from 'react';
import Box from '../layout/Box';
import classNames from 'classnames';
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import EmailTemplateEditor from "./EmailTemplateEditor";
import {paramsSerializer, postData} from "../../utils/request";
import createEditor from "../form/ComponentEditor";
import {EmailFormatter} from "../../utils/formatters";
import urldecode from "locutus/php/url/urldecode";
import {Link} from "react-router-dom";
import Icon from "../form/Icon";
import RoyaltyReportList from "./lists/RoyaltyReportList";
import BoxEditor from "./BoxEditor";
import RoyaltyReportForm from "./forms/RoyaltyReportForm";

const sortable = true;
const filterable = true;

export class RoyaltyReportEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header={"Szállítási címek"}
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                ]}
            >
                <RoyaltyReportList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header={this.state.editorHeader}
                footer={[
                    <Button
                        key="0"
                        disabled={!this.props.dirty || this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                ]}
            >
                <RoyaltyReportForm {...this.props} />
            </Editor>
        </Fragment>;
    }
}

class RoyaltyReportGenerator extends React.Component {

    render() {
        return <Fragment>
            <Box
                footer={
                    <Button
                        color="primary"
                        className="pull-right"
                        icon={{lib: "fa", name: "paper-plane"}}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            this.props.processAction(async () => {
                                return await postData({
                                    action: 'RoyaltyReport.bulkSend',
                                });
                            });
                        }}
                    >
                        Összes küldése
                    </Button>
                }
            >
                <RoyaltyReportList {...this.props} actions={true} />
            </Box>
            <Box>
                <SelectorGrid
                    ref={(licensors) => this.licensors = licensors}
                    className="p-small-table"
                    component="RoyaltyLicensor"
                    pageSize={50}
                    loading={this.props.isLoading}
                    filter={[{field: "report_due", value: 0, operator: "!="},{column: "active_royalty_count", value: 0, operator: ">"}]}
                    onLoadCompleted={(response) => {
                        response = {...response};
                        response.aggregations = [{}];
                        return response;
                    }}
                    columns={{
                        "action.view": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Link
                                        class="btn btn-default btn-xs btn-block"
                                        to={"?" + urldecode(paramsSerializer({option: "RoyaltyLicensor", licensor_id: rowData.licensor_id}))}
                                    >
                                        <Icon lib="fas" name="pencil-alt"/>
                                    </Link>
                                );
                            }
                        },
                        "name": {
                            header: "Név",
                            sortable,
                            filterable,
                        },
                        "email": {
                            header: "Email",
                            sortable,
                            filterable,
                            renderer: EmailFormatter
                        },
                        "action.send": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={async () => {
                                            await this.props.processAction(async () => {
                                                return await postData({
                                                    action: 'RoyaltyReport.create',
                                                    data: {
                                                        licensor: rowData.licensor_id
                                                    }
                                                });
                                            });
                                            this.licensors && this.licensors.refresh();
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            },
                            aggregation: () => {
                                return (
                                    <Button
                                        block={true}
                                        color="primary"
                                        size="xs"
                                        icon={{lib: "fas", name: "shapes"}}
                                        disabled={this.props.isLoading}
                                        onClick={async () => {
                                            await this.props.processAction(async () => {
                                                return await postData({
                                                    action: 'RoyaltyReport.bulkCreate'
                                                });
                                            });
                                            this.licensors && this.licensors.refresh();
                                        }}
                                    >
                                        Generálás
                                    </Button>
                                );
                            }
                        },
                        "action.preview": {
                            header: " ",
                            renderer: (v, rowData) => {
                                return (
                                    <Button
                                        block={true}
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "eye"}}
                                        disabled={this.props.isLoading}
                                        onClick={async () => {
                                            await this.props.processAction(async () => {
                                                return await postData({
                                                    action: 'RoyaltyReport.preview',
                                                    data: {
                                                        licensor: rowData.licensor_id
                                                    }
                                                });
                                            });
                                            this.licensors && this.licensors.refresh();
                                        }}
                                    >
                                        Előnézet
                                    </Button>
                                );
                            }
                        },
                    }}
                    orderBy={{field: "name", direction: "ASC"}}
                />
            </Box>
            <EmailTemplateEditor
                filter={[{field: "token", value: this.props.componentConfig.config.email_template}]}
                fieldForm={this.props.componentConfig.config.email_template}
                editorContext="RoyaltyReportEmailTemplate"
            />
        </Fragment>;
    }
}

export default createEditor({componentName: "RoyaltyReport", WrappedComponent: RoyaltyReportGenerator});
